import config from '../../config';

export default {
  url: `${config.api.baseURL}/accounts/:accountId/profiles/:profileId/unlock`,
  options: {
    method: 'POST'
  },
  transformer(data) {
    return data;
  }
};



// WEBPACK FOOTER //
// ./src/api/profiles/unlock.js